/* Shared driver for the free "Download as PDF" flow (post-PPTX export).
   POST /export-pdf → poll the never-charging preview-pdf status endpoint
   → download the blob → trigger a browser save. Throws on failure. */
import { api } from "@/lib/api";

export async function downloadDeckPdf(deckId, companyName) {
  const enq = await api.post(`/pitch/decks/${deckId}/export-pdf`);
  const jobId = enq.data.job_id;
  const pollMs = enq.data.poll_interval_ms || 2000;

  const started = Date.now();
  let status = enq.data.status;
  while (status !== "ready" && status !== "failed") {
    if (Date.now() - started > 300000) { // 5-minute cap — renders can take 2-3 min
      const err = new Error("Your PDF is still rendering in the background.");
      err.stillProcessing = true;
      throw err;
    }
    await new Promise((r) => setTimeout(r, pollMs));
    const s = await api.get(`/pitch/decks/${deckId}/preview-pdf/status/${jobId}`);
    status = s.data.status;
    if (status === "failed") throw new Error(s.data.error || "PDF generation failed");
  }

  const dl = await api.get(`/pitch/decks/${deckId}/preview-pdf/download/${jobId}`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(dl.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(companyName || "deck").replace(/\s+/g, "_")}_pitch_deck.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
